import {inject} from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class VideoMessageAPI {


    constructor(http){
        this.http = http;
    }

    save(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/videoMessage/save', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    testAnimationAPI(successCallBack) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('https://staging-output-test.s3.amazonaws.com/video_email/970/animation.gif')
            .then(data => {
                successCallBack(data);
            })

    }

    getVideo(id,token, successCallback, errorCallback) {
        console.log("get video api",id, token);
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoMessage/getUserVideo/' + id + '?Authorization=' + token + '&t=' + new Date())
            .then(data => {
                if(data.responseType== "json") {
                if (data.isSuccess) {
                    console.log("aws url api result",data);

                    var json = JSON.parse(data.response);
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            }
            else {
            successCallback(data);
            }

            });

    }

    getAdminVideo(id,token, successCallback, errorCallback) {
        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/admin/videoMessage/getUserVideo/' + id + '?Authorization=' + token + '&t=' + new Date())
            .then(data => {
                if(data.responseType== "json") {
                if (data.isSuccess) {
                    console.log("aws url api result",data);

                    var json = JSON.parse(data.response);
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            }
            else {
            successCallback(data);
            }

            });

    }

    emailGetVideo(id, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');

        });

        this.http.get('api/videoMessage/getVideo/' + id )
            .then(data => {
                if(data.responseType== "json") {
                if (data.isSuccess) {
                    console.log("aws url in email api result",data);
                    var json = JSON.parse(data.response);
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    console.log("aws url in email api error",data);

                    errorCallback(data.statusText);
                }
            }

            else {
            successCallback(data);
            }
            });


    }

    getById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoMessage/getById/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getOutlookDataById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/outlook/videoMessage/getById/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }
    getStatusById(id, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoMessage/getStatusById/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getStatsById(id, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoMessage/getStats/' + id)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("tracking_details"))
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getParams(token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        this.http.get('api/videoMessage/getParams')
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("params"))
                        successCallback(json);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getList(page, limit, sortBy, sortDir, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json')
            .withHeader("Authorization", token);

        });

        var queryString = "?page=" + page;
        queryString += "&limit=" + limit;
        queryString += "&sortBy=" + sortBy;
        queryString += "&sortDir=" + sortDir;

        this.http.get('api/videoMessage/getList' + queryString)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("videos"))
                        successCallback(json.videos);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    updateVideoPlayedNotification(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/videoMessage/updateVideoPlayedNotification', formData)
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                if(json.hasOwnProperty("videos"))
                    console.log("email notify data",json.video);
                    successCallback(json.video);

            }
            else {
                errorCallback();
            }
        });

    }

    updateRemoveReplyBack(data, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/videoMessage/updateRemoveReplyBack', formData)
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);
                if(json.hasOwnProperty("videos"))
                    console.log("email notify data",json.video);
                    successCallback(json.video);

            }
            else {
                errorCallback();
            }
        });

    }



    sendVideoEmail(data, token, successCallback, errorCallback) {
        console.log("email data",data);
        this.http = this.http.configure(x => {

            x.withHeader("Authorization", token);
        });

        this.http.post('api/videoMessage/sendVideoEmail', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    deleteVideo(data, token, successCallback, errorCallback) {

        this.http = this.http.configure(x => {

            x.withHeader("Authorization", token);
        });

        this.http.post('api/videoMessage/deleteVideo', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    getDataByKey(key, successCallback, errorCallback) {

        this.http = this.http.configure(x => {
            x.withHeader('Content-Type', 'application/json');

        });

        this.http.get('api/videoMessage/getDataByKey/' + key)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("data"))
                        successCallback(json.data);
                    else
                        errorCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    videoPlayed(data, successCallback, errorCallback) {



        this.http.post('api/videoMessage/videoPlayed', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {


                    successCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    deleteCustomPreview(videoId, successCallback, errorCallback) {



        this.http.post('api/videoMessage/deleteCustomPreview/' + videoId)
            .then(data => {

                if (data.isSuccess) {


                    successCallback();

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }




    setFrame(data, customFrame, token, successCallback, errorCallback) {

        var formData = new FormData();
        formData.append('data', JSON.stringify(data));

        if (customFrame != null)
            formData.append('frame', customFrame);


        var http = new HttpClient().configure(x => {
            x.withHeader("Authorization", token);
        });

        http.post('api/videoMessage/setFrame', formData)
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                    if(json.hasOwnProperty("video"))
                        successCallback(json.video);

                    if(json.hasOwnProperty("error"))
                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });
    }

    addCTALog(key, area, successCallback, errorCallback) {
        console.log("email data",data);

        let data = {
            'key' : key,
            'area' : area
        }
        this.http = this.http.configure(x => {

            x.withHeader('Content-Type', 'application/json')
        });

        this.http.post('api/wlusers/addCTALog', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                        successCallback(json.video);

                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

    updateAveragePercentageOfVideoEmailPlayed (key, percentage, successCallback, errorCallback) {
        let data = {
            'percentage' : percentage,
            'key' : key
        }
        this.http = this.http.configure(x => {

            x.withHeader('Content-Type', 'application/json')
        });

        this.http.post('api/wlusers/updateAveragePercentageOfVideoEmailPlayed', JSON.stringify(data))
            .then(data => {

                if (data.isSuccess) {
                    var json = JSON.parse(data.response);

                        successCallback(json.video);

                        errorCallback(json.error);

                }
                else {
                    errorCallback(data.statusText);
                }
            });

    }

}
